<template>
  <svg
    width="12"
    height="18"
    viewBox="0 0 12 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.70876 1.5V3.375M4.70876 14.625V16.5M1.04028 3.375H7.15441C8.12735 3.375 9.06045 3.67132 9.74842 4.19876C10.4364 4.72621 10.8229 5.44158 10.8229 6.1875V6.32156C10.8229 7.03193 10.4548 7.7132 9.79964 8.2155C9.14446 8.71781 8.25584 9 7.32928 9H1.04028H7.15441C8.12735 9 9.06045 9.29632 9.74842 9.82376C10.4364 10.3512 10.8229 11.0666 10.8229 11.8125V11.9466C10.8229 12.6569 10.4548 13.3382 9.79964 13.8405C9.14446 14.3428 8.25584 14.625 7.32928 14.625H1.04028V3.375Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
